"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnSubmitForm = void 0;
var Telemetry_1 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var Esignature_1 = require("@CommonFrontendBackend/Accept/Esignature");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PubSub_1 = require("@qwilr/pages-common/src/PubSub/PubSub");
var axios_1 = __importDefault(require("axios"));
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var analytics_1 = require("../Common/Utils/analytics");
var Clerk_1 = require("../AcceptFlowV2/Clerk");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var useOnSubmitForm = function (accepters, $timeout, onAuditTrailReady) {
    var publicApiBaseUrl = (0, inversify_react_1.useInjection)("publicApiBaseUrl");
    var projectCreatorProfile = (0, inversify_react_1.useInjection)("projectCreatorProfile");
    var appEvents = (0, inversify_react_1.useInjection)("appEvents");
    var utils = (0, inversify_react_1.useInjection)("utils");
    var projectId = (0, inversify_react_1.useInjection)("projectId");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var telemetry = (0, inversify_react_1.useInjection)("acceptTelemetry");
    return function (acceptanceData, isSpringboardUser) { return __awaiter(void 0, void 0, void 0, function () {
        var additionalAcceptParams, acceptPayload, anonymousUserId, _a, clerkDisabled, clerkToken, _b, acceptResponse, acceptToken, discoveryEnabled, error_1, data, res, error_2, data;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    additionalAcceptParams = "";
                    acceptPayload = (0, lodash_1.cloneDeep)(acceptanceData);
                    (0, lodash_1.extend)(acceptPayload, {
                        pageViewId: (0, analytics_1.getPageViewId)(window),
                    });
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4, Telemetry_1.Telemetry.getInstance().getAnonymousId()];
                case 2:
                    anonymousUserId = _f.sent();
                    if (anonymousUserId != null) {
                        additionalAcceptParams = "?userId=".concat(anonymousUserId);
                    }
                    return [3, 4];
                case 3:
                    _a = _f.sent();
                    return [3, 4];
                case 4:
                    _f.trys.push([4, 7, , 8]);
                    clerkDisabled = usingFeature(FeatureFlag_1.FeatureFlag.DisableClerkOnPublicPages);
                    return [4, (0, Clerk_1.getBearerTokenForAccept)(clerkDisabled)];
                case 5:
                    clerkToken = _f.sent();
                    return [4, Promise.all([
                            axios_1.default.post("".concat(publicApiBaseUrl, "/projects/").concat(projectCreatorProfile.secret, "/accept-v2").concat(additionalAcceptParams), acceptPayload, { headers: __assign({}, (0, CommonUtils_1.includeIf)(!!clerkToken, { authorization: "Bearer ".concat(clerkToken) })) }),
                            utils.delay(500),
                        ])];
                case 6:
                    _b = __read.apply(void 0, [_f.sent(), 1]), acceptResponse = _b[0];
                    acceptToken = acceptResponse.data.acceptToken ? acceptResponse.data.acceptToken : "";
                    discoveryEnabled = usingFeature(FeatureFlag_1.FeatureFlag.SpringboardAcceptDiscovery);
                    if (discoveryEnabled && acceptToken) {
                        window.localStorage.setItem("qwilr:accept-token", acceptToken);
                    }
                    if (acceptanceData.esignature) {
                        if (acceptanceData.signatureMethod && acceptanceData.signatureMethod === "saved") {
                            telemetry.track("Used Stored Signature", {});
                        }
                        else if (isSpringboardUser) {
                            telemetry.track("Saved Signature", {});
                        }
                    }
                    return [3, 8];
                case 7:
                    error_1 = _f.sent();
                    if (axios_1.default.isAxiosError(error_1) && error_1.response) {
                        data = error_1.response.data;
                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)((_c = data.message) !== null && _c !== void 0 ? _c : "An unknown error occurred")];
                    }
                    return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)("Looks like your security settings blocked this request. We recommend checking your network and security settings.")];
                case 8:
                    $timeout(function () {
                        var incomingAccepter = {
                            name: acceptanceData.name,
                            acceptedAt: new Date().toString(),
                            esignature: acceptanceData.esignature ? (0, Esignature_1.esignatureDataFromImage)(acceptanceData.esignature) : undefined,
                            signatureMethod: acceptanceData.signatureMethod,
                        };
                        if (accepters.finalisedAccepters) {
                            accepters.finalisedAccepters.push(incomingAccepter);
                        }
                        else {
                            accepters.finalisedAccepters = [incomingAccepter];
                        }
                    });
                    _f.label = 9;
                case 9:
                    _f.trys.push([9, 11, , 12]);
                    return [4, axios_1.default.get("".concat(publicApiBaseUrl, "/projects/").concat(projectId, "/audit-trail-pdf"))];
                case 10:
                    res = _f.sent();
                    if (res.data) {
                        onAuditTrailReady(res.data);
                    }
                    return [3, 12];
                case 11:
                    error_2 = _f.sent();
                    if (axios_1.default.isAxiosError(error_2)) {
                        data = (_d = error_2.response) === null || _d === void 0 ? void 0 : _d.data;
                        console.error((_e = data === null || data === void 0 ? void 0 : data.message) !== null && _e !== void 0 ? _e : "An unknown error occurred while fetching the audit trail PDF");
                    }
                    return [3, 12];
                case 12:
                    PubSub_1.PubSub.publish("qwilr:project-accepted", {
                        projectAccepted: true,
                    });
                    appEvents.emit("accepted", { version: 2 });
                    return [2];
            }
        });
    }); };
};
exports.useOnSubmitForm = useOnSubmitForm;
